import { versionRowPresentation } from 'src/components/star-grid/utils/versionPickerPresentation';
import { liveVersion } from 'src/components/star-grid/utils/versionCatalog';
import { SelectProps } from '@amzn/awsui-components-core/select';
import { PnlDataVersion, PnlDeckGroup } from 'src/components/star-grid/reportSelectors.types';
import { PnlReportConfig } from 'src/components/star-grid/starGridTypes';

export const versionOptions = (versions: readonly PnlDataVersion[], unavailable: string): SelectProps.Options =>
  versions.map((version) => ({
    value: version.version,
    label: versionRowPresentation(version).displayLabel,
    ...(version.resolvable === false ? { disabled: true, description: unavailable } : {})
  }));

export const selectedVersionOption = (versions: readonly PnlDataVersion[], timestamp?: string): SelectProps.Option | null => {
  const selected = timestamp ? versions.find((version) => version.as_of === timestamp) : liveVersion(versions);
  if (selected) return { value: selected.version, label: versionRowPresentation(selected).displayLabel };
  return timestamp ? { value: timestamp, label: timestamp } : null;
};

export const deckOptions = (groups: readonly PnlDeckGroup[], definition: PnlReportConfig | undefined, unassigned: string): SelectProps.Options => {
  if (!definition) return [];
  const current = groups.find((group) => group.reports.some((report) => report.pnl_report_id === definition.pnl_report_id));
  const category = definition.deck_report ?? current?.deck_report;
  return groups
    .filter((group) => group.deck_report === category)
    .flatMap((group) =>
      group.reports.map((report) => ({
        value: String(report.pnl_report_id),
        label: group.deck_type ?? unassigned,
        description: report.report_name
      }))
    );
};
